import { render, staticRenderFns } from "./report-opener.vue?vue&type=template&id=1781f6e6&scoped=true&lang=pug&"
import script from "./report-opener.vue?vue&type=script&lang=js&"
export * from "./report-opener.vue?vue&type=script&lang=js&"
import style0 from "./report-opener.vue?vue&type=style&index=0&id=1781f6e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1781f6e6",
  null
  
)

export default component.exports